import { render, staticRenderFns } from "./Ppn_paid.vue?vue&type=template&id=a5a22442&scoped=true"
import script from "./Ppn_paid.vue?vue&type=script&lang=js"
export * from "./Ppn_paid.vue?vue&type=script&lang=js"
import style0 from "./Ppn_paid.vue?vue&type=style&index=0&id=a5a22442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a22442",
  null
  
)

export default component.exports